import React from 'react';
import { ServerErrorSvg } from './illustrations/server-error-svg';

interface ServerErrorProps {
  status?: number;
  message?: string;
}

export const ServerError: React.FC<ServerErrorProps> = ({ status = 500, message }) => {
  return (
    <div className="text-center space-y-6 animate-in fade-in zoom-in-95 duration-500">
      {/* Dynamic SVG Illustration */}
      <div className="flex justify-center my-2">
        <ServerErrorSvg />
      </div>

      {/* Heading & Subtitle */}
      <div className="space-y-3 max-w-lg mx-auto">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight">
          Server Error ({status})...
        </h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm sm:text-base leading-relaxed">
          {message || "We encountered an unexpected server error. Please try again or reload the page."}
        </p>
      </div>
    </div>
  );
};

export default ServerError;
